export * from "./template-preview-page.component";
